import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { GetCatalogProviders, GetCategories, ShowLayout } from '@shared/state/shared/shared.action';
import { take } from 'rxjs/operators';
import { VkService } from '@shared/services/vk.service';
import { StyleSettingService } from '../../services/style-setting.service';
import { AppStateService } from '../../modules/apps/services/app-state.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {
  private _rootFontSize = 10;
  public isAppeals = false;
  constructor(
    private store: Store,
    private elRef: ElementRef,
    private styleSettingService: StyleSettingService,
    private appState: AppStateService,
    private vkService: VkService
  ) {
    this.store.dispatch(new ShowLayout(false));
    styleSettingService.recoverySettingFromLocalStorage();
    styleSettingService.changeMaterialTheme(true);
  }

  private smallResize(windowWidth: number): void {
    const percentOfNumber = this._rootFontSize - (windowWidth / 1024) * this._rootFontSize;
    this.elRef.nativeElement.style.fontSize = `${this._rootFontSize - percentOfNumber}px`;
  }

  public ngOnInit(): void {
    this.store.dispatch(new GetCategories());
    this.store.dispatch(new GetCatalogProviders());
    this.appState.getAllPlatforms().pipe(take(1)).subscribe();
    this.vkService.getPostsInfo().pipe(take(1)).subscribe();
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: any): void {
    if (event.target.innerWidth < 1024) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.smallResize(event.target.innerWidth);
    } else if (this.elRef.nativeElement.style.fontSize !== '10px') {
      this.elRef.nativeElement.style.fontSize = '10px';
    }
  }

  public ngAfterViewInit(): void {
    if (window) {
      if (window.innerWidth < 1024) {
        this.smallResize(window.innerWidth);
      }
    }
  }

  public ngOnDestroy(): void {
    this.styleSettingService.changeMaterialTheme(false);
    this.store.dispatch(new ShowLayout(true));
  }
}
